<style scoped>
.navbar-brand-box-alt {
  padding: 0 0.8rem !important;
  text-align: left !important;
}
.text-portal {
  color: rgb(255, 255, 255);
  padding: 0 0.5rem;
  font-size: 15px;
}
.text-portal-light {
  color: rgb(0, 0, 0);
  padding: 0 0.5rem;
  font-size: 15px;
}
.header-profile {
  height: 50px;
  width: 50px;
  background-color: #f6f6f6;
  padding: 3px;
}
</style>
<script>
/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
      ],
      value: null,
      nmRazao: null,
      cdPessoa: null,
      sqUsuario: null,
      tpPessoa: null,
      menu: true,
      fotoPerfil: require("@/assets/images/user.png"),
    };
  },
  mounted() {},
  created() {
    this.getNomeRazaoUsuario();
  },
  methods: {
    getNomeRazaoUsuario() {
      this.$http
        .get("api/auth/me")
        .then((response) => {
          this.nmRazao = response.data.nm_razao;
          this.cdPessoa = response.data.cd_pessoa;
          this.sqUsuario = response.data.sq_usuario;
          this.tpPessoa = response.data.tp_Pessoa.cd_tp_pessoa;
          if (response.data.foto) {
            this.fotoPerfil = this.$caminhoFotoPerfil + response.data.foto;
          }
        })
        .catch((err) => {
          console.log(err);
          this.logoutUser();
        });
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale) {
      this.lan = locale;
    },
    logoutUser() {
      this.$store
        .dispatch("logout")
        .then(() => {
          this.$router.push("/login");
        })
        .catch(() => {
          this.$router.push("/login");
        });
    },
    ativarDebug() {},
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box navbar-brand-box-alt">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img
                src="@/assets/images/logo-unicampo-small.png"
                alt
                height="40"
              />
            </span>
            <span class="logo-lg">
              <img
                src="@/assets/images/logo-unicampo-small.png"
                alt
                height="50"
              />
              <span class="text-portal-light">Portal Unicampo</span>
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img
                src="@/assets/images/logo-unicampo-small.png"
                alt
                height="45"
              />
            </span>
            <span class="logo-lg">
              <img
                src="@/assets/images/logo-unicampo-small.png"
                alt
                height="50"
              />
              <span class="text-portal">Portal Unicampo</span>
            </span>
          </router-link>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <button
            id="vertical-menu-btn"
            type="button"
            class="btn btn-sm px-3 font-size-16 header-item"
            @click="$tools.menu"
          >
            <i class="fa fa-fw fa-bars"></i>
          </button>
          <button
            id="vertical-menu-btn"
            type="button"
            class="btn btn-sm px-3 font-size-16 header-item"
            style="display: none"
            @click="$store.commit('SET_DEBUG')"
          >
            Debug
            <label v-if="$store.state.debug" class="text-success">ON</label>
            <label v-else class="text-danger">OFF</label>
          </button>
        </div>
      </div>

      <div class="d-flex">
        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile"
              :src="fotoPerfil"
              alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ms-1">
              {{ nmRazao }}
              <small>[{{ cdPessoa }}]</small>
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <div v-if="this.tpPessoa == 1 || this.tpPessoa == 5">
            <router-link tag="a" to="/perfilPessoal/cadastroPessoal">
              <button class="dropdown-item">
                <i class="bx bx-user-circle font-size-16 align-middle me-1">
                </i>
                Perfil
              </button>
            </router-link>
            <b-dropdown-divider></b-dropdown-divider>
          </div>
          <router-link tag="b" to="/redefinicaoSenha">
            <button class="dropdown-item">
              <i class="bx bx-lock-alt font-size-16 align-middle me-1"> </i>
              Alterar Senha
            </button>
          </router-link>

          <b-dropdown-divider></b-dropdown-divider>
          <button class="dropdown-item text-danger" @click="logoutUser()">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            Sair
          </button>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
